import React from 'react';
import cls from 'classnames';

import { reduxForm, Field } from 'redux-form';

import FlexRow from 'src/explore/elements/FlexRow';
import FlexCol from 'src/explore/elements/FlexCol';
import FormGroup from 'src/explore/elements/FormGroup';
import { LoadingButton } from 'src/shoppe/elements/LoadingButton';

const Form = ({ btnClass, className, handleSubmit, linkClass, loading, onBack }) => (
  <form className={className} onSubmit={handleSubmit}>
    <FlexRow>
      <FlexCol>
        <FormGroup>
          <Field
            name="email"
            type="email"
            component="input"
            className="v2-form__input"
            placeholder="Your Email"
            required
          />
        </FormGroup>
      </FlexCol>
    </FlexRow>

    <FlexRow>
      <FlexCol>
        <LoadingButton
          className={cls( btnClass, 'btn btn-block btn-secondary py-3 font-weight-bold' )}
          loading={loading}
          type="submit"
        >
          Reset Password
        </LoadingButton>
      </FlexCol>
    </FlexRow>

    <div className="mt-6 fs-4">
      {'Did you remember it? '}
      <a href="javascript:" className={linkClass} onClick={onBack}>
        Log In
      </a>
    </div>
  </form>
);

export default reduxForm({
  form: 'forgot-password',
})( Form );
